import StoredLayout from '../../layouts/StoredLayout'
import Alerts from './Alerts'
export default StoredLayout(Alerts)
